import React from 'react';
import {
  Box, Flex, Text, Button, Icon, HStack, Progress, VStack, CloseButton,
} from '@chakra-ui/react';
import { LuCheck, LuCircle } from 'react-icons/lu';
import { useTranslation } from 'react-i18next';

// MI-297: persistent getting-started card. A distinct banner (never a row inside
// the movements list). Shows progress, lets the user resume the wizard at the
// first pending step, and can be dismissed. It auto-hides once everything is
// done (the parent stops rendering it when `showChecklist` is false).
export default function GettingStartedChecklist({ onb, onResume, onDismiss }) {
  const { t } = useTranslation('onboarding');
  const { steps, doneCount, totalCount } = onb;

  return (
    <Box
      m={{ base: 3, md: 4 }}
      p={{ base: 4, md: 5 }}
      bg="redesign.bg.surface"
      borderWidth="1px"
      borderColor="redesign.border"
      borderRadius="xl"
      boxShadow="card"
    >
      <Flex justify="space-between" align="flex-start" mb={3}>
        <Box>
          <Text fontWeight="bold" fontSize="md" letterSpacing="-0.01em" color="redesign.heading">{t('checklist.title')}</Text>
          <Text fontSize="sm" color="redesign.text.muted">{t('checklist.progress', { done: doneCount, total: totalCount })}</Text>
        </Box>
        <CloseButton size="sm" onClick={onDismiss} aria-label={t('checklist.hide')} />
      </Flex>

      {/* A sunken track, filled in the ok-mark green. */}
      <Progress
        value={(doneCount / totalCount) * 100} size="xs" borderRadius="full" mb={4}
        bg="redesign.bg.sunken" sx={{ '& > [role=progressbar]': { bg: 'redesign.accent.green' } }}
      />

      <VStack align="stretch" spacing={2} mb={4}>
        {steps.map((s) => (
          <HStack key={s.key} spacing={2}>
            <Icon as={s.done ? LuCheck : LuCircle} color={s.done ? 'redesign.accent.green' : 'redesign.text.faint'} boxSize={4} />
            <Text fontSize="sm" color={s.done ? 'redesign.text.muted' : 'redesign.text'} textDecoration={s.done ? 'line-through' : 'none'}>
              {t(`steps.${s.key}`)}
            </Text>
          </HStack>
        ))}
      </VStack>

      <Button size="sm" colorScheme="blue" onClick={onResume}>
        {t('checklist.resume')}
      </Button>
    </Box>
  );
}
